import { useEffect, useState } from "react";
import { INDUSTRIES } from "../../data/industries";

const WA = "https://wa.me/917995495312?text=Hi%20Aria%20—%20I'd%20like%20a%20free%20AI%20consultation";

const Hero = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIdx((i) => (i + 1) % INDUSTRIES.length);
    }, 4200);
    return () => clearInterval(id);
  }, []);

  const goSolutions = () => {
    const el = document.getElementById("solutions");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const active = INDUSTRIES[idx];

  return (
    <section className="hero" data-bg="cream" data-testid="hero-section">
      <div className="hero-warm-glow" />
      <div className="hero-inner-grid">
        {/* LEFT — text */}
        <div className="hero-text">
          <div className="hero-eyebrow">
            <span className="pulse" />
            Agentic AI · Intelligent Automation · AI Employees
          </div>
          <h1 className="hero-h1">
            AI Employees<br />
            <span className="gold-word">for modern businesses.</span>
          </h1>
          <p className="hero-sub">
            Automate sales, customer support, operations, and decision-making
            with Agentic AI, UiPath, WhatsApp AI, and intelligent automation.
          </p>
          <p className="hero-body">
            Aria helps mid-sized businesses deploy AI Employees and Agentic AI
            to increase revenue, reduce operational costs, improve customer
            experience — and scale without increasing headcount.
          </p>
          <div className="hero-ctas">
            <a href={WA} target="_blank" rel="noreferrer" className="btn btn-gold" data-testid="hero-cta-wa">
              Book a free AI consultation
            </a>
            <button className="btn btn-outline-g" onClick={goSolutions} data-testid="hero-cta-solutions">
              Explore AI solutions
            </button>
          </div>
        </div>

        {/* RIGHT — HD slideshow */}
        <div className="hero-slideshow" data-testid="hero-slideshow">
          <div className="hero-slide-stack">
            {INDUSTRIES.map((ind, i) => (
              <div
                key={ind.key}
                className={`hero-slide ${ind.grad} ${i === idx ? "active" : ""}`}
                style={{ backgroundImage: `url(${ind.img})` }}
                aria-hidden={i !== idx}
              >
                <div className="hero-slide-tint" />
                <div className="hero-slide-grad" />
                <div className="hero-slide-content">
                  <div className="hero-slide-meta">
                    <span className="hero-slide-icon">{ind.icon}</span>
                    <span className="hero-slide-label">{ind.label}</span>
                  </div>
                  <h3 className="hero-slide-title">{ind.title}</h3>
                  <p className="hero-slide-vision">{ind.future.vision}</p>
                  <div className="hero-slide-roi">
                    <span className="dot" />
                    {ind.future.roi}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="hero-slide-progress">
            {INDUSTRIES.map((ind, i) => (
              <button
                key={ind.key}
                className={`hero-slide-dot ${i === idx ? "active" : ""}`}
                onClick={() => setIdx(i)}
                aria-label={`Show ${ind.title}`}
                data-testid={`hero-dot-${ind.key}`}
              />
            ))}
          </div>
          <div className="hero-slide-counter">
            <span className="num">{String(idx + 1).padStart(2, "0")}</span>
            <span className="sep">/</span>
            <span className="total">{String(INDUSTRIES.length).padStart(2, "0")}</span>
            <span className="dash">—</span>
            <span className="active-name">{active.title}</span>
          </div>
        </div>
      </div>

      <button className="hero-scroll-hint" onClick={goSolutions} aria-label="Scroll down" data-testid="hero-scroll-hint">
        <span>Explore</span>
        <span className="hero-mouse" />
      </button>
    </section>
  );
};

export default Hero;
